module.exports = __webpack_public_path__ + "img/ml3108.35211ef1.png";